import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_db0@0.3.2_encoding@0.1.13_eslint@9.27._i7au66tvklk3txt25dxlkk54ai/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  manifest_45route_45rule
]
export const namedMiddleware = {}